/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-undef */
/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import $ from 'jquery';
import { DateTime, shortUsaDateFormat } from 'common/utils/date';

class DateRangePickerClass extends Component {
  static customRangeLabel(range) {
    return `${range.start.toFormat(shortUsaDateFormat)} - ${range.end.toFormat(shortUsaDateFormat)}`;
  }

  static applyLabel(range) {
    const label = range.label || this.customRangeLabel(range);
    $('input[name="daterange"]').val(label);
  }

  constructor(props) {
    super(props);

    if (this.props.onApply === undefined) {
      this.props.onApply = () => {};
    }

    this.defaultRange = this.defaultRange.bind(this);
    this.setUpDateRangePicker = this.setUpDateRangePicker.bind(this);
  }

  componentDidMount() {
    this.setUpDateRangePicker();
  }

  componentDidUpdate() {
    this.setUpDateRangePicker();
  }

  setUpDateRangePicker() {
    const range =
      this.props.range.start && this.props.range.end ? this.props.range : this.defaultRange();

    $('input[name="daterange"]').daterangepicker({
      startDate: range.start,
      endDate: range.end,
      autoUpdateInput: false,
      ranges: {
        'last 7 days': [DateTime.now().minus({ days: 6 }), DateTime.now()],
        'last 30 days': [DateTime.now().minus({ days: 29 }), DateTime.now()],
        'last 90 days': [DateTime.now().minus({ days: 89 }), DateTime.now()],
        'this week': [DateTime.now().startOf('week'), DateTime.now().endOf('week')],
        'this month': [DateTime.now().startOf('month'), DateTime.now().endOf('month')],
      },
      timestamp: this.props.range.solicitation_reporting_timestamp,
    });

    $('input[name="daterange"]').on('apply.daterangepicker', (event, picker) => {
      this.props.onApply(event, picker);
      DateRangePickerClass.applyLabel({
        start: picker.startDate,
        end: picker.endDate,
        label:
          picker.chosenLabel !== picker.locale.customRangeLabel ? picker.chosenLabel : undefined,
      });
    });

    DateRangePickerClass.applyLabel(range);
  }

  defaultRange() {
    return {
      start: DateTime.now().minus({ days: 6 }),
      end: DateTime.now(),
      label: 'last 7 days',
    };
  }

  render() {
    return <input name="daterange" />;
  }
}

export default DateRangePickerClass;

/* eslint-enable react/react-in-jsx-scope */
/* eslint-enable no-undef */
/* eslint-enable react/no-deprecated */
